<template>
  <a v-if="latest" class="cf" :href="href" aria-label="Read the newest Daily Chocobo">
    <span class="cf-mast">
      <span class="cf-name">{{ latest.paper.name }}</span>
      <span class="cf-line">No. {{ latest.no }} · {{ longDate }}<template v-if="fresh"> · {{ fresh }}</template></span>
    </span>
    <span class="cf-story">
      <span class="cf-head">{{ latest.issue.headline }}</span>
      <span class="cf-deck">{{ latest.issue.deck }}</span>
    </span>
    <span class="cf-by">
      <img class="cf-pic" :src="portrait" :alt="latest.paper.reporter.cls" @error="$event.target.style.visibility = 'hidden'">
      <span>By {{ latest.paper.reporter.name }}<b>Read the issue →</b></span>
    </span>
  </a>
</template>

<script>
// 📰 The homepage's front-page card for the Daily Chocobo (2026-10-24): the newest issue's masthead, headline, deck and
// reporter, linking to it. It keeps the paper's own look (serif, the blackletter masthead) so it reads as the paper,
// not as another site panel. Loads after the page (lib/chocoboLatest.js, shared with the ticker's line).
import { latestIssue, issueWhen, issueHref } from '../lib/chocoboLatest.js';
import { UNITS_BASE } from '../lib/assetUrls.js';

export default {
  name: 'ChocoboFront',
  data() { return { latest: null }; },
  mounted() {
    const go = () => latestIssue().then((l) => { this.latest = l; });
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 4000 }); else setTimeout(go, 1500);
  },
  computed: {
    href() { return issueHref(this.latest.issue.date); },
    fresh() { const w = issueWhen(this.latest.issue.date); return w === 'Yesterday' || w === 'Today' ? w + '’s chat' : ''; },
    longDate() { const [y, m, d] = this.latest.issue.date.split('-').map(Number); return new Date(y, m - 1, d).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); },
    portrait() { const r = this.latest.paper.reporter; return UNITS_BASE + r.cls + (r.gender === 'X' ? '' : r.gender) + '.gif'; },
  },
};
</script>

<style scoped>
.cf { display: grid; grid-template-columns: auto minmax(0, 1fr) auto; align-items: center; gap: 18px; margin: 4px 0 16px; padding: 12px 18px;
  text-align: left; text-decoration: none; color: #f1e6c8; font-family: Georgia, 'Times New Roman', serif;
  background: linear-gradient(180deg, #2a2418, #1a160e); border: 1px solid #6b5a36; border-radius: 4px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.5), inset 0 0 0 3px rgba(255, 244, 214, 0.04); }
.cf:hover { border-color: #c9a75a; }
.cf:hover .cf-by b { text-decoration: underline; }
.cf-mast { display: flex; flex-direction: column; gap: 2px; padding-right: 18px; border-right: 1px solid #6b5a36; }
.cf-name { font-family: 'Old English Text MT', 'UnifrakturMaguntia', Georgia, serif; font-size: 26px; font-weight: 700; color: #fff4d6; line-height: 1.05; white-space: nowrap; }
.cf-line { font-size: 11px; text-transform: uppercase; letter-spacing: 0.6px; color: #c8b98f; white-space: nowrap; }
.cf-story { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
.cf-head { font-size: 26px; font-weight: 700; line-height: 1.05; color: #fff4d6; letter-spacing: 0.3px; }
.cf-deck { font-style: italic; font-size: 15px; color: #ffd877; }
.cf-by { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #c8b98f; }
.cf-by span { display: flex; flex-direction: column; }
.cf-by b { font-family: var(--cond); font-size: 14px; letter-spacing: 1px; text-transform: uppercase; color: var(--brass-hi); }
.cf-pic { width: 40px; height: 40px; object-fit: contain; image-rendering: pixelated; }
@media (max-width: 820px) {
  .cf { grid-template-columns: minmax(0, 1fr); gap: 8px; }
  .cf-mast { border-right: 0; padding-right: 0; border-bottom: 1px solid #6b5a36; padding-bottom: 6px; }
  .cf-name { font-size: 22px; } .cf-line { white-space: normal; }
  .cf-head { font-size: 22px; }
}
</style>
